import { getCommaSeparatedNumber } from '@lyearn/core/utils/number/getCommaSeparatedNumber';
import { getFormattedPercentage } from '@lyearn/core/utils/number/getFormattedPercentage';

export const formatNumberValue = (value: number) => getCommaSeparatedNumber(value);

export const formatPercentValue = (value: number) => getFormattedPercentage(value);

export const adaptTickValues = (tickValues: number[]) => {
  if (tickValues.length > 2) {
    return [tickValues[0], tickValues[tickValues.length - 1]];
  }

  return tickValues;
};
